<script setup>
import {computed} from 'vue'
import {useRoute} from 'vue-router'

const props = defineProps({
    reportsModule: {
        type: Object,
        required: true,
        default: () => ({})
    }
})

const route = useRoute()

const formData = computed(() => props.reportsModule?.formData || {})
const reports = computed(() => props.reportsModule?.reports || [])

const reportName = route.query?.reportName || ''

if (formData.value) {
    formData.value.reportName = reportName
}
</script>

<template>
    <select v-model="formData.reportName" class="form-select form-select-sm" name="reportName">
        <option value="" selected disabled>Select a report&hellip;</option>
        <option v-for="report in reports" :key="report.name" :value="report.name">
            {{ report.label }}
        </option>
    </select>
</template>